/* @ngInject */
const pieceResource = (
  $resource,
  paths
) => {
  const path = `${paths.handlers.piece}/:action`

  return $resource(
    path,
    { action: '@action' }, {
    'update': {
      method: 'PUT',
    },
    'query': {
      method: 'GET',
    },
    'get': {
      method: 'GET',
      isArray: false,
    },
    'post': {
      method: 'POST',
    },
  }
  )
}
export default pieceResource



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/piece/services/resource.service.js